import { useEffect, useState, createContext } from "react";
import Button from "../Button";
import CartHeader from "../CartHeader";
import Footer from "../Footer";
import Product from "../Product";
import { serverPath } from "../../helpers/variables";


export const AppContext = createContext(null);

const Cart = () => {
  const [cart, setCart] = useState(null);
  const [total, setTotal] = useState(null);
  const [fetchData, setFetchData] = useState(true);

  useEffect(() => {
    fetch(`${serverPath}products/`)
      .then((res) => res.json())
      .then((data) => {
        // console.log(data)
        setCart(data);
      });
  }, [fetchData]); //работает при первичном рендеринге и каждый раз когда меняется fetchData
  useEffect(() => {
    if (cart) {
      setTotal(() => {
        return {
          price: cart.reduce((prev, current) => prev + current.priceTotal, 0),
          count: cart.reduce((prev, current) => prev + current.count, 0),
        };
      });
    }
  }, [cart]); //как только изменилась карзина, то мы пересчитываем общую стоимость и количество

  const deleteProduct = (id) => {
    // setCart( cart => cart.filter(product => product.id !=id ))
    fetch(`${serverPath}products/` + id, {
      method: "DELETE",
    }).then((res) => {
      res.ok && setFetchData((value) => !value);
    });
  };

  const increase = (id) => {
    // console.log(id)
    const product = cart.find((product) => id === product.id);

    const data = {
      ...product,
      count: ++product.count,
      priceTotal: ++product.count * product.price,
    };

    fetch(`${serverPath}products/` + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      res.ok && setFetchData(!fetchData);
    });
  };
  // setCart((cart)=>{
  //     return cart.map((product)=>{
  //         if(product.id === id){
  //             return {
  //                 ...product,
  //                 count: ++product.count,
  //                 priceTotal: ++product.count * product.price
  //             }
  //         }
  //         return product
  //     })
  // })}
  const decrease = (id) => {
    const product = cart.find((product) => id === product.id);
    const newCount = product.count - 1 > 1 ? product.count - 1 : 1;
    const data = {
      ...product,
      count: newCount,
      priceTotal: newCount * product.price,
    };
    fetch(`${serverPath}products/` + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      res.ok && setFetchData(!fetchData);
    });
  };

  // setCart((cart)=>{
  //     return cart.map((product)=>{
  //         if(product.id === id){
  //             const newCount = product.count - 1 > 1 ? product.count - 1 : 1
  //             return {
  //                 ...product,
  //                 count: newCount,
  //                 priceTotal: newCount * product.price

  //             }
  //         }
  //         return product
  //     })
  // })}
  const changeValue = (id, value) => {
    const product = cart.find((product) => id === product.id);
    const data = {
      ...product,
      count: value,
      priceTotal: value * product.price,
    };
    fetch(`${serverPath}products/` + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      res.ok && setFetchData(!fetchData);
    });
    // setCart((cart)=>{
    //     return cart.map((product)=>{
    //         if(product.id === id){
    //             return {
    //                 ...product,
    //                 count: value,
    //                 priceTotal: value * product.price
    //             }
    //         }
    //         return product
    //     })
    // })
  };
  const addProduct = () => {
    console.log("Add log");
    const titles = ["Mac Pro", "Apple", "Macbook"];
    const img = ["mac-pro.jpg", "apple-watch.jpg", "macbook.jpg"];
    const prices = [10000, 19000, 9000, 25000];

    const randomValue = (array) => {
      return array[Math.floor(Math.random() * array.length)];
    };
    const price = randomValue(prices);

    const data = {
      img: randomValue(img),
      title: randomValue(titles),
      count: 1,
      price: price,
      priceTotal: price,
    };
    console.log(data);

    fetch(`${serverPath}products/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      res.ok && setFetchData(!fetchData);
    });
  };

  const products = () => {
    return cart.map((product) => {
        return (
          <Product
            deleteProduct={deleteProduct}
            product={product}
            key={product.id}
          />
        );
      })
  }

  return (
    <AppContext.Provider value={{deleteProduct, increase, decrease, changeValue, addProduct} }>
      <section className="cart">
        <CartHeader />
        {cart && products()}
        {total && <Footer total={total} />}
      </section>

      <section className="button-wrapper">
        <Button title="Add product"/>
      </section>
    </AppContext.Provider>
  );
};

export default Cart;
